"use client";
import React, { useState, useEffect } from "react";
import LoaderOverlay from '../../components/LoaderOverlay';
// Usamos los mismos estilos de Programas Académicos para replicar el diseño
import styles from "../../styles/PantallaDeProgramasAcademicos.v2.module.css";
import estudiantesStyles from "../../styles/EstudiantesStyles/Estudiantes.module.css";
import HeaderGlobal from "../../components/HeaderGlobal";
import Sidebar from "../../components/Sidebar";
import SeccionesTable from "./SeccionesTable";
import NuevaSeccionModal from "./NuevaSeccionModal";
import { parseJwt } from '../../api/parseJwt';
import { createCycle, getCycles, updateCycle, deleteCycle } from "../../api/ciclosEscolares";
import Toast from '../DocentesScreen/Toast';

function PantallaDeSecciones() {
  const [openNew, setOpenNew] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [editMode, setEditMode] = useState(false);
  const [selectedCiclo, setSelectedCiclo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState("");
  // Estado para contadores
  const [contadores, setContadores] = useState({
    planeados: 0,
    activos: 0,
    cerrados: 0,
    total: 0
  });

  // Cargar y calcular contadores
  const loadContadores = async () => {
    try {
      setLoading(true);
      const ciclos = await getCycles();
      const planeados = ciclos.filter(c => c.estado_ciclo === 'PLANEADO').length;
      const activos = ciclos.filter(c => c.estado_ciclo === 'ACTIVO').length;
      const cerrados = ciclos.filter(c => c.estado_ciclo === 'CERRADO').length;
      setContadores({
        planeados,
        activos,
        cerrados,
        total: ciclos.length
      });
    } catch (error) {
      console.error('Error al cargar contadores:', error);
    } finally {
      setLoading(false);
    }
  };

  // Cargar contadores al montar y cuando cambie refreshTrigger
  useEffect(() => {
    loadContadores();
  }, [refreshTrigger]);
  
  const handleCreated = async (data) => {
    try {
      if (editMode && selectedCiclo) {
        // Actualizar ciclo existente
        await updateCycle(selectedCiclo.id, data);
        alert('Ciclo escolar actualizado correctamente');
      } else {
        // Crear nuevo ciclo
        // Obtener id usuario logeado del JWT
        const token = localStorage.getItem('authToken');
        const payload = parseJwt(token);
        const usuarioId = payload?.user_id || payload?.id_usuario || payload?.id;
        console.log('🟢 Nuevo ciclo escolar: usuarioId extraído del JWT:', usuarioId);
        console.log('🟢 Payload enviado a createCycle:', { ...data, usuario_creacion: usuarioId });
        await createCycle({ ...data, usuario_creacion: usuarioId });
        alert('Ciclo escolar registrado correctamente');
      }
      setRefreshTrigger(prev => prev + 1); // Refresh table
      setOpenNew(false);
      setEditMode(false);
      setSelectedCiclo(null);
      return true;
    } catch (error) {
      console.error('Error al guardar ciclo escolar:', error);
      alert(`Error al guardar el ciclo escolar: ${error.message || 'Por favor intenta de nuevo.'}`);
      return false;
    }
  };

  const handleView = (ciclo) => {
    // Por ahora, editar es suficiente para ver
    handleEdit(ciclo);
  };

  const handleEdit = (ciclo) => {
    setSelectedCiclo(ciclo);
    setEditMode(true);
    setOpenNew(true);
  };

  const handleDelete = async (ciclo) => {
    if (window.confirm(`¿Está seguro de eliminar el ciclo ${ciclo.anio}-${ciclo.numero_periodo}?`)) {
      try {
        await deleteCycle(ciclo.id);
        setRefreshTrigger(prev => prev + 1); // Refresh table
        alert('Ciclo escolar eliminado correctamente');
      } catch (error) {
        console.error('Error al eliminar ciclo escolar:', error);
        alert('Error al eliminar el ciclo escolar. Por favor intenta de nuevo.');
      }
    }
  };

  const handleNewCiclo = () => {
    setEditMode(false);
    setSelectedCiclo(null);
    setOpenNew(true);
  };

  const handleCloseModal = () => {
    setOpenNew(false);
    setEditMode(false);
    setSelectedCiclo(null);
  };

  const handleSearch = () => {
    // En el futuro se puede filtrar SeccionesTable usando `query`
    console.log('Buscando ciclos con término:', query);
  };
  return (
    <div className={styles.mainContainer}>
      <div className={styles.layout}>
        <div className={styles.sidebarColumn}>
          <Sidebar />
        </div>
        <div className={styles.contentColumn}>
          <HeaderGlobal title="Ciclos Escolares" />
          <main className={styles.mainContent}>
            <div className={styles.contentArea}>
              <div className={styles.contentWrapper} style={{ position: 'relative' }}>
                <LoaderOverlay visible={loading} label="Cargando ciclos..." />
                <div className={estudiantesStyles.searchSection}>
                  <div className={estudiantesStyles.searchCard}>
                    <div className={styles.programsSearchRow}>
                      <div className={estudiantesStyles.searchInputGroup}>
                        <svg
                          className={estudiantesStyles.searchIcon}
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
                            stroke="#898d8d"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <input
                          type="text"
                          className={estudiantesStyles.searchInput}
                          placeholder="Buscar Ciclo..."
                          aria-label="Buscar ciclo"
                          value={query}
                          onChange={(e) => setQuery(e.target.value)}
                          onKeyPress={(e) => {
                            if (e.key === 'Enter') handleSearch();
                          }}
                        />
                      </div>

                      <button
                        className={styles.buscarButtonProgramas}
                        onClick={handleSearch}
                      >
                        Buscar
                      </button>

                      <button
                        className={styles.newProgramButton}
                        aria-label="Crear nuevo ciclo"
                        onClick={handleNewCiclo}
                      >
                        + Nuevo Ciclo
                      </button>
                    </div>
                  </div>
                </div>

                {/* Recuadros resumen de ciclos - dinámicos */}
                <div style={{ display: 'flex', gap: '18px', margin: '18px 0 24px 0', width: '100%' }}>
                  <div style={{ flex: 1, background: '#fff', borderRadius: '6px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderLeft: '4px solid #1a3764', padding: '16px 0 16px 18px', display: 'flex', flexDirection: 'column', justifyContent: 'center', minWidth: '120px' }}>
                    <span style={{ fontSize: '11px', color: '#1a3764', fontWeight: 500, marginBottom: '2px', letterSpacing: '0.5px' }}>CICLOS PLANEADOS</span>
                    <span style={{ fontSize: '22px', color: '#1a3764', fontWeight: 700 }}>{contadores.planeados}</span>
                  </div>
                  <div style={{ flex: 1, background: '#fff', borderRadius: '6px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderLeft: '4px solid #2e7d32', padding: '16px 0 16px 18px', display: 'flex', flexDirection: 'column', justifyContent: 'center', minWidth: '120px' }}>
                    <span style={{ fontSize: '11px', color: '#2e7d32', fontWeight: 500, marginBottom: '2px', letterSpacing: '0.5px' }}>CICLOS ACTIVOS</span>
                    <span style={{ fontSize: '22px', color: '#2e7d32', fontWeight: 700 }}>{contadores.activos}</span>
                  </div>
                  <div style={{ flex: 1, background: '#fff', borderRadius: '6px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderLeft: '4px solid #c62828', padding: '16px 0 16px 18px', display: 'flex', flexDirection: 'column', justifyContent: 'center', minWidth: '120px' }}>
                    <span style={{ fontSize: '11px', color: '#c62828', fontWeight: 500, marginBottom: '2px', letterSpacing: '0.5px' }}>CICLOS CERRADOS</span>
                    <span style={{ fontSize: '22px', color: '#c62828', fontWeight: 700 }}>{contadores.cerrados}</span>
                  </div>
                  <div style={{ flex: 1, background: '#fff', borderRadius: '6px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderLeft: '4px solid #1a3764', padding: '16px 0 16px 18px', display: 'flex', flexDirection: 'column', justifyContent: 'center', minWidth: '120px' }}>
                    <span style={{ fontSize: '11px', color: '#1a3764', fontWeight: 500, marginBottom: '2px', letterSpacing: '0.5px' }}>TOTAL</span>
                    <span style={{ fontSize: '22px', color: '#1a3764', fontWeight: 700 }}>{contadores.total}</span>
                  </div>
                </div>

                {/* Tabla de secciones académicas */}
                <SeccionesTable 
                  refreshTrigger={refreshTrigger}
                  onView={handleView}
                  onEdit={handleEdit}
                  onDelete={handleDelete}
                />
              </div>
            </div>
          </main>
        </div>
      </div>
      <NuevaSeccionModal 
        open={openNew} 
        onClose={handleCloseModal} 
        onSubmit={handleCreated}
        editMode={editMode}
        cicloData={selectedCiclo}
      />
      <Toast />
    </div>
  );
}

export default PantallaDeSecciones;
